import { useState } from 'react';
import TopNavbar from '../../components/ui/TopNavbar';
import Icon from '../../components/AppIcon';
import FolderTree from './components/FolderTree';
import DocumentGrid from './components/DocumentGrid';
import DocumentPreview from './components/DocumentPreview';
import UploadModal from './components/UploadModal';
import SearchBar from './components/SearchBar';

const DocumentManagementCenter = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const folderStructure = [
    {
      id: 'root',
      name: 'All Documents',
      icon: 'FolderOpen',
      count: 247,
      children: [
        {
          id: 'shipments',
          name: 'Shipments',
          icon: 'Ship',
          count: 156,
          children: [
            {
              id: 'shp-001',
              name: 'SHP-2024-001',
              icon: 'Folder',
              count: 24
            },
            {
              id: 'shp-002',
              name: 'SHP-2024-002',
              icon: 'Folder',
              count: 18
            },
            {
              id: 'shp-003',
              name: 'SHP-2024-003',
              icon: 'Folder',
              count: 32
            }
          ]
        },
        {
          id: 'invoices',
          name: 'Invoices',
          icon: 'Receipt',
          count: 45
        },
        {
          id: 'contracts',
          name: 'Contracts',
          icon: 'FileText',
          count: 12
        },
        {
          id: 'certificates',
          name: 'Certificates',
          icon: 'Award',
          count: 28
        },
        {
          id: 'reports',
          name: 'Reports',
          icon: 'BarChart3',
          count: 6
        }
      ]
    }
  ];

  const mockDocuments = [
    {
      id: 'doc-001',
      name: 'Commercial Invoice - SHP-2024-001.pdf',
      type: 'pdf',
      size: 2457600,
      uploadDate: '2024-12-10T14:30:00',
      uploadedBy: 'Sarah Johnson',
      category: 'Invoice',
      version: 2,
      thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcc47960-1764916764480.png",
      thumbnailAlt: 'Commercial invoice document showing itemized list of coal shipment charges with company letterhead and payment terms',
      linkedShipment: 'SHP-2024-001',
      vessel: 'MV Ocean Pride',
      tags: ['urgent', 'approved', 'final'],
      description: 'Final commercial invoice for coal shipment including all charges and payment terms',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Sarah Johnson',
          timestamp: '2024-12-10T14:30:00'
        },
        {
          icon: 'Edit',
          action: 'Document updated to version 2',
          user: 'Michael Chen',
          timestamp: '2024-12-11T09:15:00'
        },
        {
          icon: 'CheckCircle',
          action: 'Document approved',
          user: 'David Williams',
          timestamp: '2024-12-11T16:45:00'
        }
      ]
    },
    {
      id: 'doc-002',
      name: 'Bill of Lading - Ocean Pride.pdf',
      type: 'pdf',
      size: 1843200,
      uploadDate: '2024-12-09T10:15:00',
      uploadedBy: 'Michael Chen',
      category: 'Bill of Lading',
      version: 1,
      thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcc47960-1764916764480.png",
      thumbnailAlt: 'Bill of lading document with shipping details, cargo information, and official stamps from port authority',
      linkedShipment: 'SHP-2024-001',
      vessel: 'MV Ocean Pride',
      tags: ['original', 'signed'],
      description: 'Original bill of lading for coal shipment from Newcastle to Mumbai',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Michael Chen',
          timestamp: '2024-12-09T10:15:00'
        },
        {
          icon: 'Eye',
          action: 'Document viewed',
          user: 'Sarah Johnson',
          timestamp: '2024-12-09T14:20:00'
        }
      ]
    },
    {
      id: 'doc-003',
      name: 'Quality Certificate - Lab Report.pdf',
      type: 'pdf',
      size: 3276800,
      uploadDate: '2024-12-08T16:45:00',
      uploadedBy: 'David Williams',
      category: 'Certificate',
      version: 1,
      thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_13c9f99b9-1765029210779.png",
      thumbnailAlt: 'Laboratory quality certificate showing coal analysis results with graphs, tables, and official laboratory seal',
      linkedShipment: 'SHP-2024-001',
      vessel: 'MV Ocean Pride',
      tags: ['lab-tested', 'certified'],
      description: 'Independent laboratory quality analysis certificate for coal grade specifications',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'David Williams',
          timestamp: '2024-12-08T16:45:00'
        }
      ]
    },
    {
      id: 'doc-004',
      name: 'Customs Declaration - Export.xlsx',
      type: 'xlsx',
      size: 524288,
      uploadDate: '2024-12-07T11:30:00',
      uploadedBy: 'Emma Davis',
      category: 'Customs Document',
      version: 3,
      linkedShipment: 'SHP-2024-002',
      vessel: 'MV Pacific Star',
      tags: ['customs', 'export'],
      description: 'Export customs declaration with detailed cargo information and valuation',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Emma Davis',
          timestamp: '2024-12-07T11:30:00'
        },
        {
          icon: 'Edit',
          action: 'Document revised',
          user: 'Emma Davis',
          timestamp: '2024-12-08T09:00:00'
        },
        {
          icon: 'Edit',
          action: 'Final revision completed',
          user: 'Emma Davis',
          timestamp: '2024-12-09T13:20:00'
        }
      ]
    },
    {
      id: 'doc-005',
      name: 'Inspection Report - Pre-shipment.pdf',
      type: 'pdf',
      size: 4194304,
      uploadDate: '2024-12-06T14:00:00',
      uploadedBy: 'James Wilson',
      category: 'Inspection Report',
      version: 1,
      thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_10dcf7394-1764775996292.png",
      thumbnailAlt: 'Pre-shipment inspection report with photographs of coal stockpile, quality testing procedures, and inspector signatures',
      linkedShipment: 'SHP-2024-002',
      vessel: 'MV Pacific Star',
      tags: ['inspection', 'pre-shipment'],
      description: 'Comprehensive pre-shipment inspection report with quality verification and photographs',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'James Wilson',
          timestamp: '2024-12-06T14:00:00'
        },
        {
          icon: 'Download',
          action: 'Document downloaded',
          user: 'Sarah Johnson',
          timestamp: '2024-12-07T10:30:00'
        }
      ]
    },
    {
      id: 'doc-006',
      name: 'Contract Agreement - RNR Trading.pdf',
      type: 'pdf',
      size: 1572864,
      uploadDate: '2024-12-05T09:20:00',
      uploadedBy: 'Sarah Johnson',
      category: 'Contract',
      version: 1,
      thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1504053bf-1764783239720.png",
      thumbnailAlt: 'Legal contract document with multiple pages showing terms and conditions, pricing schedules, and signature blocks',
      linkedShipment: 'SHP-2024-003',
      vessel: 'MV Global Trader',
      tags: ['contract', 'signed', 'legal'],
      description: 'Master trading contract agreement between RVA and RNR for coal supply',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Sarah Johnson',
          timestamp: '2024-12-05T09:20:00'
        },
        {
          icon: 'Eye',
          action: 'Document reviewed',
          user: 'David Williams',
          timestamp: '2024-12-05T15:40:00'
        }
      ]
    },
    {
      id: 'doc-007',
      name: 'Payment Receipt - Advance.pdf',
      type: 'pdf',
      size: 819200,
      uploadDate: '2024-12-04T13:50:00',
      uploadedBy: 'Michael Chen',
      category: 'Invoice',
      version: 1,
      linkedShipment: 'SHP-2024-003',
      vessel: 'MV Global Trader',
      tags: ['payment', 'advance'],
      description: 'Payment receipt for 33% advance payment received from buyer',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Michael Chen',
          timestamp: '2024-12-04T13:50:00'
        }
      ]
    },
    {
      id: 'doc-008',
      name: 'Vessel Nomination - Global Trader.docx',
      type: 'docx',
      size: 245760,
      uploadDate: '2024-12-03T10:30:00',
      uploadedBy: 'Emma Davis',
      category: 'Other',
      version: 2,
      linkedShipment: 'SHP-2024-003',
      vessel: 'MV Global Trader',
      tags: ['vessel', 'nomination'],
      description: 'Vessel nomination notice with technical specifications and loading schedule',
      activity: [
        {
          icon: 'Upload',
          action: 'Document uploaded',
          user: 'Emma Davis',
          timestamp: '2024-12-03T10:30:00'
        },
        {
          icon: 'Edit',
          action: 'Document updated',
          user: 'Emma Davis',
          timestamp: '2024-12-04T08:15:00'
        }
      ]
    }
  ];

  const [documents, setDocuments] = useState(mockDocuments);

  const handleDocumentSelect = (doc) => {
    setSelectedDocument(doc);
  };

  const handleUpload = () => {
    setShowUploadModal(true);
  };

  const handleSaveUpload = (files, metadata) => {
    console.log('Uploading files:', files, metadata);
    // TODO: Implement actual upload to Supabase Storage
    alert(`✅ ${files?.length} file(s) uploaded successfully!`);
    setShowUploadModal(false);
  };

  const handleDownload = (docId) => {
    console.log('Downloading document:', docId);
    // TODO: Implement download from Supabase Storage
    alert('✅ Document download started!');
  };

  const handleDelete = (docId) => {
    if (confirm('Are you sure you want to delete this document?')) {
      console.log('Deleting document:', docId);
      // TODO: Implement deletion
      alert('✅ Document deleted successfully!');
    }
  };

  const handleShare = (docId) => {
    const email = prompt('Enter email address to share with:');
    if (email) {
      console.log('Sharing document:', docId, email);
      // TODO: Implement sharing
      alert(`✅ Document shared with ${email}`);
    }
  };

  const handlePreview = (doc) => {
    setSelectedDocument(doc);
    setShowPreviewModal(true);
  };

  const handleClosePreview = () => {
    setShowPreviewModal(false);
    setSelectedDocument(null);
  };

  const handleSearch = (query) => {
    console.log('Searching for:', query);
    // TODO: Implement search functionality
  };

  const handleFolderSelect = (folderId) => {
    setSelectedFolder(folderId);
    console.log('Folder selected:', folderId);
    // TODO: Load documents for folder
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        {/* Mobile-optimized header */}
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex-1 min-w-0">
              <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                Document Management
              </h1>
              <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                Manage shipment documents and files
              </p>
            </div>
            
            <div className="flex items-center gap-2 flex-wrap">
              <button 
                onClick={() => setIsUploadModalOpen(true)}
                className="px-3 sm:px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-2 text-xs sm:text-sm min-h-[44px] sm:min-h-auto flex-1 sm:flex-initial justify-center"
              >
                <Icon name="Upload" size={16} />
                <span className="hidden sm:inline">Upload</span>
                <span className="sm:hidden">Upload</span>
              </button>
              <button className="px-3 sm:px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/90 transition-colors flex items-center gap-2 text-xs sm:text-sm min-h-[44px] sm:min-h-auto">
                <Icon name="Filter" size={16} />
                <span className="hidden sm:inline">Filter</span>
              </button>
            </div>
          </div>

          {/* Search bar - full width on mobile */}
          <div className="mt-3">
            <SearchBar onSearch={handleSearch} onFilterToggle={() => {}} />
          </div>
        </header>

        {/* Main content - responsive layout */}
        <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
          {/* Mobile: Stack vertically, Desktop: 3-panel horizontal layout */}
          <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 h-full">
            {/* Folder Tree - collapsible on mobile */}
            <div className="w-full lg:w-1/4 bg-card rounded-lg border border-border">
              <div className="p-3 sm:p-4 border-b border-border lg:hidden">
                <button
                  onClick={() => {/* Toggle folder tree on mobile */}}
                  className="flex items-center justify-between w-full text-sm font-semibold"
                >
                  <span>Folders</span>
                  <Icon name="ChevronDown" size={16} />
                </button>
              </div>
              <div className="overflow-auto max-h-[300px] lg:max-h-full">
                <FolderTree
                  folders={folderStructure}
                  selectedFolder={selectedFolder}
                  onFolderSelect={handleFolderSelect}
                />
              </div>
            </div>

            {/* Document Grid - main content area */}
            <div className="flex-1 bg-card rounded-lg border border-border overflow-hidden">
              <DocumentGrid
                documents={documents}
                onDocumentSelect={handleDocumentSelect}
                selectedDocument={selectedDocument}
                onUpload={() => setIsUploadModalOpen(true)}
              />
            </div>

            {/* Document Preview - modal on mobile, sidebar on desktop */}
            {selectedDocument && (
              <>
                {/* Mobile: Full-screen overlay */}
                <div className="lg:hidden fixed inset-0 bg-black/50 z-50" onClick={() => setSelectedDocument(null)} />
                <div className="lg:hidden fixed inset-x-0 bottom-0 top-20 bg-card rounded-t-2xl z-50 overflow-auto">
                  <div className="sticky top-0 bg-card border-b border-border p-4 flex items-center justify-between">
                    <h3 className="font-semibold truncate flex-1">Document Preview</h3>
                    <button
                      onClick={() => setSelectedDocument(null)}
                      className="p-2 hover:bg-muted rounded-lg transition-colors"
                    >
                      <Icon name="X" size={20} />
                    </button>
                  </div>
                  <DocumentPreview
                    document={selectedDocument}
                    onClose={() => setSelectedDocument(null)}
                  />
                </div>

                {/* Desktop: Side panel */}
                <div className="hidden lg:block w-1/4 bg-card rounded-lg border border-border overflow-hidden">
                  <DocumentPreview
                    document={selectedDocument}
                    onClose={() => setSelectedDocument(null)}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <UploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUpload={handleUpload}
      />
    </div>
  );
};

export default DocumentManagementCenter;